import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UpgradePopupService } from 'src/app/pages/ui-components/shared/upgrade-popup.service';
import { LoggingService } from 'src/app/services/consoleLogs';

@Injectable()
export class PaymentInterceptor implements HttpInterceptor {
  private popupOpen = false;

  constructor(private paymentService: UpgradePopupService, private loggingService: LoggingService) {
    this.paymentService.showPopup$.subscribe(isOpen => {
      this.popupOpen = isOpen;
    });
  }

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   if (this.popupOpen && !req.url.includes('payment')) {
  //     this.paymentService.closePaymentPopup();
  //     this.loggingService.log('Closing popup on new API request');
  //   }

  //   return next.handle(req).pipe(
  //     catchError((error: HttpErrorResponse) => {
  //       if (error.status === 402) {
  //         const componentName = this.getComponentNameFromRequest(req);
  //         const message = error.error?.message || 'Access restricted. Please upgrade your plan.';
  //         this.paymentService.showPaymentPopup(message, componentName);
  //         this.loggingService.log('showPaymentPopup=>>>>>');
  //       }
  //       return throwError(() => error);
  //     })
  //   );
  // }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ⛔ Don’t close popup if the request is for payment or upgrade
    if (
      this.popupOpen &&
      !req.url.includes('payment') &&
      !req.url.includes('newServiceRequest') &&
      !req.url.includes('requestModule')
    ) {
      this.paymentService.closePaymentPopup();
      this.loggingService.log('Closing popup on new API request');
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 402) {
          const componentName = this.getComponentNameFromRequest(req);
          const message =
            error.error?.message || 'Access restricted. Please upgrade your plan.';
          this.paymentService.showPaymentPopup(message, componentName);
          this.loggingService.log('showPaymentPopup=>>>>>');
        }
        return throwError(() => error);
      })
    );
  }



  private getComponentNameFromRequest(req: HttpRequest<any>): string {
    const url = req.url.toLowerCase();
    try {
      const urlObj = new URL(url);
    } catch (e) {
      this.loggingService.log('🔍 Not a valid URL, using raw string');
    }
    if (url.includes('analaytics')) return 'module';
    if (url.includes('module?page=')) return 'module';
    if (url.includes('addDoctor')) return 'doctors';
    if (url.includes('webinar')) return 'webinar';
    if (url.includes('webinar-list')) return 'webinar';
    if (url.includes('calender')) return 'webinar';
    if (url.includes('elibrary')) return 'elibrary';
    if (url.includes('news')) return 'news';
    if (url.includes('newslist')) return 'news';
    if (url.includes('reports')) return 'reports';
     if (url.includes('podcast')) return 'podcast';

    const componentHeader = req.headers.get('X-Component-Name');
    if (componentHeader) return componentHeader;

    return 'This Feature';
  }
}